export const headers = {
    initialHeaders: [
        { title: "Tipo de examen", field: "exam", child: null },
        { title: "Nombre del empleado", field: "nameEmployee", child: null },
        { title: "Cargo", field: "charge", child: null },
        { title: "Fecha de notificación", field: "dateNotification", child: null },
        { title: "Regional", field: "regional", child: null },
    ],
}